<template>
  <modal>

    <div class="waiting-modal-container">
      <LoaderComponent></LoaderComponent>
      <span>
        {{ text }}
      </span>
    </div>
  </modal>
</template>

<script>
import { defineComponent } from 'vue';
import Modal from './Modal.vue';
import LoaderComponent from './LoaderComponent.vue';

export default defineComponent({
    components: {
        Modal, LoaderComponent
    },
    props: {
        text: { type: String },
    },
});
</script>

<style scoped>
.waiting-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  height: 140px;
  width: 300px;
  font-weight: 400;
  font-size: var(--font-size-small);
  color: var(--color-principal);
}
</style>
